import api from './api';
import { createInviteAdminApi } from './invite-admin-api';

export const inviteAdminApi = createInviteAdminApi(api);
